import Check from '../../icons/Check';
import COLOR from '../../constant/colorset';

interface Props {
  checked: boolean;
  iconColor?: string;
}

export default function CheckFlatIcon({ checked = false, iconColor = COLOR.kurlyPurple }: Props) {
  return (
    <>
      <Check stroke={checked ? iconColor : COLOR.lightGray} strokeWidth={1.5} />
    </>
  );
}
